import React from 'react';
import dayjs from 'dayjs';
import { DatePicker } from 'ALIASED-antd';
import { SessionFormItem } from '@components/Clinicians/Session/Components/SessionFormItem';
import { useSessionFormState } from '@hooks/useSessionFormState';
import { useSessionAction } from '@hooks/useSessionAction';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { type ApptActionCodes } from 'vl-common/src/schemas/getMetaAppointments';

const AUTH_START_LABELS: Record<ApptActionCodes, string | undefined> = {
  BKVCON: 'Select the date to book the consultation',
  REFF2F: 'Self-booking start date',
  DISCHG: undefined,
  PRESCR: undefined,
  INVREQ: undefined,
  REF2AE: undefined,
  TRCARE: undefined,
  PTFACT: undefined
};

export const AuthStartDateFormItem = ({
  onChange = () => {},
  actionCode
}: {
  onChange?: (value: dayjs.Dayjs) => void;
  actionCode: ApptActionCodes;
}) => {
  const { AUTH_START_KEY } = useSessionAction(actionCode);

  const {
    appointment: { appointment_completed: isCompleted, read_only: readonly }
  } = useSessionAppointment();
  const [authStartDate, setAuthStartDate] = useSessionFormState(AUTH_START_KEY);

  return (
    <SessionFormItem
      label={AUTH_START_LABELS[actionCode]}
      name={AUTH_START_KEY}
      data-testid="auth-start-date"
      valuePropName="authStartDate"
    >
      <DatePicker
        disabled={isCompleted || readonly}
        defaultValue={authStartDate ? dayjs(authStartDate) : undefined}
        value={authStartDate ? dayjs(authStartDate) : undefined}
        format="DD/MM/YYYY"
        onChange={(e) => {
          setAuthStartDate(e ? e.startOf('day').toDate() : undefined);
          onChange(e);
        }}
        style={{ width: '100%' }}
        disabledDate={(current: any) => current?.isBefore(dayjs()?.startOf('day'))}
      />
    </SessionFormItem>
  );
};
